<div class="notification-title">
  <h1>{{ notification.title }}</h1>
  <button (click)="close.emit()" mat-icon-button><mat-icon>close</mat-icon></button>
</div>

<div class="date-container">
  <div class="date">
    <div class="title"><mat-icon>schedule_send</mat-icon>Versand geplant</div>
    <div class="value">{{ getDate(notification, true) }}</div>
  </div>

  <div class="date">
    <div class="title"><mat-icon>send</mat-icon>Versand effektiv</div>
    <div class="value">{{ getDate(notification) }}</div>
  </div>
</div>

<div class="text">{{ notification.text }}</div>

<h2>Statistiken</h2>

<div class="statistics">
  <div class="stat">
    <mat-icon>group</mat-icon>
    <div class="value">{{ receivers?.length }}</div>
    <div class="title">Empfänger</div>
  </div>
  <div class="stat">
    <mat-icon>visibility</mat-icon>
    <div class="value">{{ notification?.read?.length }} ({{ ((notification?.read?.length / receivers?.length) * 100) | number: '1.0-2' }}%)</div>
    <div class="title">Gelesen</div>
  </div>
  <div class="stat">
    <mat-icon>mail</mat-icon>
    <div class="value">{{ receivers?.length - notification?.read?.length }}
      ({{ (((receivers?.length - notification?.read?.length) / receivers?.length) * 100) | number: '1.0-2' }}%)
    </div>
    <div class="title">Ungelesen</div>
  </div>
</div>
<div class="graph">
  <div class="full"><div class="value" [style.width]="((notification?.read?.length / receivers?.length) * 100) + '%'"></div></div>
  <div class="value">({{ ((notification?.read?.length / receivers?.length) * 100) | number: '1.0-2' }}%)</div>
</div>

<h2>Empfänger</h2>

<div class="groups">
  <ng-container *ngIf="!notification?.groupIds?.length">
    <div class="group"><mat-icon>group</mat-icon>Alle Benutzer<span>{{ receivers?.length }}</span></div>
  </ng-container>
  <ng-container *ngIf="!!notification?.groupIds?.length">
    <div class="group" *ngFor="let group of activeGroups">
      <mat-icon>group</mat-icon>{{ getGroupTitle(group.name) }}<span>{{ group.description }}</span>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="contentTitle">
  <h2>Verknüpfter Inhalt</h2>
  <div class="connected-content"><mat-icon>link_2</mat-icon>{{contentTitle}}</div>
</ng-container>
